<template>
  <ApolloQuery
    @result="(resultObject) => resultHandle(resultObject)"
    :query="query"
    :variables="variables"
    :pollInterval="pollInterval"
  >
    <template v-slot="{ times, result: { loading, error, data } }">
      <div v-if="times == 0">
        <slot name="skeleton-loader">
          <v-skeleton-loader type="article" />
        </slot>
      </div>

      <!-- Loading -->
      <div v-else-if="loading">
        <slot name="loading">
          Loading...
        </slot>
      </div>

      <!-- Error -->
      <div v-else-if="error">
        <slot name="error">
          An error occurred
        </slot>
      </div>

      <!-- Result -->
      <slot name="result" v-else-if="data"> data loaded {{ data }} </slot>

      <!-- No result -->
      <div v-else>
        <slot name="no-result"> No result :(</slot>
      </div>
    </template>
  </ApolloQuery>
</template>

<script>
  export default {
    name: "apollo",
    model: {
      prop: "result",
      event: "change",
    },
    props: {
      result: {
        type: [Object, Array],
        default: () => {},
      },
      query: Object,
      variables: {
        type: Object,
        default: () => {},
      },
      pollInterval: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      resultHandle(event) {
        let element = null;
        for (const key in event.data) {
          element = event.data[key];
          break;
        }

        this.$emit("change", element);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
